var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"convention-section-title"},[_c('typo',{attrs:{"id":_vm.id,"name":`cc-${_vm.type}`}},[_c('span',{ref:"element",domProps:{"innerHTML":_vm._s(_vm.title)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }